module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Left Chaise_Cloud.b1490d40.png";